<div
  class="portal-modal-shell"
  [class.portal-modal-shell--overlay]="showOverlay"
  [class.portal-modal-shell--embedded]="!showOverlay"
  role="presentation"
  portalBackdropDismiss
  (portalBackdropDismiss)="onOverlayClick()">
  <div
    class="portal-modal-shell__dialog"
    [class.portal-modal-shell__dialog--sm]="size === 'sm'"
    [class.portal-modal-shell__dialog--md]="size === 'md'"
    [class.portal-modal-shell__dialog--lg]="size === 'lg'"
    [class.portal-modal-shell__dialog--xl]="size === 'xl'"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title ? 'portalModalShellTitle' : null"
    (click)="$event.stopPropagation()">
    <div class="portal-modal-shell__content">
      <header class="portal-modal-shell__header portal-dark-chrome portal-chrome-surface">
        <div class="portal-modal-shell__titles min-w-0">
          <ng-content select="[portalModalLead]"></ng-content>
          <div class="portal-modal-shell__copy min-w-0">
            <h2 class="portal-modal-shell__title" id="portalModalShellTitle" *ngIf="title">
              {{ title }}
            </h2>
            <p class="portal-modal-shell__subtitle mb-0 text-truncate" *ngIf="subtitle" [attr.title]="subtitle">
              {{ subtitle }}
            </p>
            <ng-content select="[portalModalHeader]"></ng-content>
          </div>
        </div>
        <app-portal-button
          *ngIf="showClose"
          layout="icon"
          variant="light"
          size="sm"
          iconClass="ki-solid ki-cross"
          extraClass="portal-dark-chrome__glass-btn"
          [disabled]="busy || !dismissible"
          [ariaLabel]="closeAriaLabel || ('COMMON.CLOSE' | translate)"
          [attr.title]="closeAriaLabel || ('COMMON.CLOSE' | translate)"
          (pressed)="onCloseClick()">
        </app-portal-button>
      </header>

      <div class="portal-modal-shell__body">
        <ng-content></ng-content>
      </div>

      <footer class="portal-modal-shell__footer">
        <ng-content select="[portalModalFooter]"></ng-content>
      </footer>
    </div>
  </div>
</div>
